export const LOGIN_USER = {
  LOGIN_USER: '/login/',
  REFRESH_TOKEN: '/login/refresh/',
  LOGOUT_USER: '/logout/',
  CURRENT_USER: '/api/v1/ums/users/current_user/',
}
